/* eslint-disable @ngrx/prefer-effect-callback-in-block-statement */
import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { catchError, filter, map, mergeMap, of } from 'rxjs';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';

import { ComparisonService } from '@cdba/compare/service/comparison.service';
import { Comparison } from '@cdba/shared/models/comparison.model';

import {
  areBomIdentifiersForSelectedBomItemsLoaded,
  loadBomSuccess,
  loadComparisonSummary,
  loadComparisonSummaryFailure,
  loadComparisonSummarySuccess,
} from '../..';
import { getBomIdentifiersForSelectedBomItems } from '../../selectors';

@Injectable()
export class ComparisonSummaryEffects {
  private readonly actions$ = inject(Actions);
  private readonly comparisonService = inject(ComparisonService);
  private readonly store = inject(Store);

  loadComparisonSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadComparisonSummary),
      concatLatestFrom(() =>
        this.store.select(getBomIdentifiersForSelectedBomItems)
      ),
      mergeMap(([_action, identifiers]) =>
        this.comparisonService.getComparison(identifiers).pipe(
          map((comparison: Comparison) =>
            loadComparisonSummarySuccess({ comparison })
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              loadComparisonSummaryFailure({
                errorMessage: error.error?.detail ?? error.message,
                statusCode: error.status,
              })
            )
          )
        )
      )
    )
  );

  triggerDataLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBomSuccess),
      concatLatestFrom(() =>
        this.store.select(areBomIdentifiersForSelectedBomItemsLoaded)
      ),
      filter(([_action, areLoaded]) => areLoaded),
      map(() => loadComparisonSummary())
    )
  );
}
